<template>
    <span v-html="processedContent" />
  </template>
  
  <script>
  import katex from "katex";
  import "katex/dist/katex.min.css";
  
  export default {
    name: "KatexRenderer",
    props: {
      expression: {
        type: String,
        required: true,
      },
    },
    computed: {
      processedContent() {
        const regex = /\$\$(.+?)\$\$|\\\[(.+?)\\\]|\$(.+?)\$/g;
        let result = "";
        let lastIndex = 0;
        let match;
  
        while ((match = regex.exec(this.expression)) !== null) {
          const latex = match[1] || match[2] || match[3]; // ✅ Fixed
          result += this.escapeHtml(this.expression.slice(lastIndex, match.index));
          try {
            result += katex.renderToString(latex, {
              throwOnError: false,
              displayMode: match[1] || match[2] ? true : false, // ✅ auto detect inline/display
            });
          } catch (e) {
            result += this.escapeHtml(match[0]); // fallback
          }
          lastIndex = regex.lastIndex;
        }
  
        result += this.escapeHtml(this.expression.slice(lastIndex));
        return result;
      },
    },
    methods: {
      escapeHtml(text) {
        return text
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;");
      },
    },
  };
  </script>
  